import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum VideoAttachmentPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
}

export const VideoAttachmentResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.VIDEO_ATTACHMENT).default(ResourceType.VIDEO_ATTACHMENT),
    description: z.string(),
});
export const VideoAttachmentMutationResourceSchema = getMutationSchema(VideoAttachmentResourceSchema);

export type VideoAttachmentResource = z.infer<typeof VideoAttachmentResourceSchema>;

export const defaultVideoAttachmentResource: VideoAttachmentResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.VIDEO_ATTACHMENT,
    description: '',
};

export function useVideoAttachmentActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/video-attachment',
            ResourceType.VIDEO_ATTACHMENT,
            VideoAttachmentResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/video-attachment',
            ResourceType.VIDEO_ATTACHMENT,
            VideoAttachmentResourceSchema
        ),
    };
}
